import { Alert } from 'components/ui/alert';
import { ApiErrorAlert } from 'components/ui/api-error-alert';
import { LoadingMessage } from 'components/Loader/LoadingMessage';
import PageCartoItem from 'components/PageCarto/List/PageCartoItem';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  getSimplePaginationItems,
} from 'components/ui/pagination';
import { useService } from 'hooks/useService';
import { ApiError } from 'interfaces/api';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { ContentType } from 'services/abstract';

export const PageCartoList = () => {
  const [page, setPage] = useState(1);
  const paginationLimit = 9;
  const pageCartoService = useService(ContentType.PAGE_CARTOS);
  const {
    data: response,
    isError,
    error,
    isLoading,
  } = useQuery({
    queryKey: ['latest-page-carto', page],
    queryFn: async () => {
      return await pageCartoService.getLatestPageCartos(page, paginationLimit);
    },
    keepPreviousData: true,
  });

  if (isLoading) {
    return <LoadingMessage data-testid="loading-message" />;
  }

  if (isError) {
    return <ApiErrorAlert error={error as ApiError} />;
  }

  if (!response || response.data.length === 0) {
    return <Alert variant="info">Aucun contenu à afficher.</Alert>;
  }

  const { data, meta } = response;
  const totalPages = meta.pagination.pageCount || 0;
  const paginationItems = getSimplePaginationItems(page, totalPages);
  const hasPrevious = page > 1;
  const hasNext = page < totalPages;

  return (
    <div>
      <div className="grid grid-cols-3 gap-y-10 gap-x-6">
        {data.map((page) => {
          return <PageCartoItem key={page.id} {...page} />;
        })}
      </div>
      <div className="flex flex-row mt-5 justify-center">
        <Pagination>
          <PaginationContent
            data-testid="pagination"
            className="flex-wrap justify-center"
          >
            {hasPrevious && (
              <PaginationItem>
                <PaginationPrevious
                  data-testid="pagination-previous"
                  onClick={() => setPage(page - 1)}
                />
              </PaginationItem>
            )}
            {paginationItems.map((pageNumber) => (
              <PaginationItem key={pageNumber}>
                <PaginationLink
                  isActive={pageNumber === page}
                  disabled={pageNumber === page}
                  onClick={() => setPage(pageNumber)}
                >
                  {pageNumber}
                </PaginationLink>
              </PaginationItem>
            ))}
            {hasNext && (
              <PaginationItem>
                <PaginationNext
                  data-testid="pagination-next"
                  onClick={() => setPage(page + 1)}
                />
              </PaginationItem>
            )}
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  );
};
